import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

// ─────────────────────────────────────────────────────────────────────────────
// GOOGLE SHEETS SETUP — follow README.md steps to get your Web App URL
// Then paste it here:
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbz0nHOPI52RG8Xv695KUz04Hg9uUV_2hbfyJ2DrTHM-FbgFhlxNzbZ5eoXyPzUzxIrlBQ/exec';
// ─────────────────────────────────────────────────────────────────────────────

const INIT = { name: '', company: '', email: '', phone: '', country: '', product: '', volume: '', message: '' };

export default function Contact() {
  const [form, setForm]     = useState(INIT);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const validate = () => {
    const e = {};
    if (!form.name.trim())                              e.name    = 'Required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email  = 'Valid email required';
    if (!form.product)                                  e.product = 'Required';
    if (!form.message.trim())                           e.message = 'Required';
    return e;
  };

  const change = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(er => ({ ...er, [name]: null }));
  };

  const submit = async e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setStatus('loading');

    try {
      // Send to Google Apps Script → saves to Google Sheets
      await fetch(GOOGLE_SCRIPT_URL, {
        method:  'POST',
        mode:    'no-cors', // required for Google Apps Script
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ ...form, submittedAt: new Date().toISOString() }),
      });
      // no-cors means we can't read the response, but if no error thrown = success
      setStatus('success');
      setForm(INIT);
    } catch (err) {
      console.error('Submission error:', err);
      setStatus('error');
    }
  };

  return (
    <main className="contact-page">
      <section className="contact-page__hero">
        <div className="contact-page__hero-inner">
          <span className="eyebrow eyebrow--light">Get In Touch</span>
          <h1>Work With Us</h1>
          <p>
            We are actively exploring partnerships with importers, distributors, and foodservice
            suppliers. Request specifications, pricing, or samples.
          </p>
        </div>
      </section>

      <section className="contact-page__body">
        <div className="contact-page__inner">

          {/* ── Form ── */}
          <div className="contact-page__form-col">
            {status === 'success' ? (
              <div className="contact-success">
                <div className="contact-success__icon">✓</div>
                <h2>Enquiry Received</h2>
                <p>
                  Thank you. Rakesh Chandrashekar will respond within{' '}
                  <strong>48 hours</strong>.
                </p>
                <button className="btn btn--outline" onClick={() => setStatus('idle')}>
                  Send Another
                </button>
              </div>
            ) : (
              <form className="cf" onSubmit={submit} noValidate>
                <h2 className="cf__title">Export Enquiry</h2>

                <div className="cf__row">
                  <F label="Full Name *" error={errors.name}>
                    <input name="name" value={form.name} onChange={change}
                           placeholder="Your name" className={errors.name ? 'err' : ''} />
                  </F>
                  <F label="Company / Organisation">
                    <input name="company" value={form.company} onChange={change}
                           placeholder="Optional" />
                  </F>
                </div>

                <div className="cf__row">
                  <F label="Email Address *" error={errors.email}>
                    <input name="email" type="email" value={form.email} onChange={change}
                           placeholder="you@company.com" className={errors.email ? 'err' : ''} />
                  </F>
                  <F label="Phone / WhatsApp">
                    <input name="phone" type="tel" value={form.phone} onChange={change}
                           placeholder="+country code + number" />
                  </F>
                </div>

                <div className="cf__row">
                  <F label="Country">
                    <input name="country" value={form.country} onChange={change}
                           placeholder="UK / Germany / UAE…" />
                  </F>
                  <F label="Product of Interest *" error={errors.product}>
                    <select name="product" value={form.product} onChange={change}
                            className={errors.product ? 'err' : ''}>
                      <option value="">Select</option>
                      <option>Cold Pressed Sesame Oil</option>
                      <option>Cold Pressed Groundnut Oil</option>
                      <option>Cold Pressed Coconut Oil</option>
                      <option>Cold Pressed Castor Oil</option>
                      <option>Multiple Products</option>
                    </select>
                  </F>
                </div>

                <F label="Estimated Volume / Frequency">
                  <input name="volume" value={form.volume} onChange={change}
                         placeholder="e.g. 500 L/month, trial order…" />
                </F>

                <F label="Message / Requirements *" error={errors.message}>
                  <textarea name="message" rows={4} value={form.message} onChange={change}
                            placeholder="Tell us about your business, supply needs, or questions."
                            className={errors.message ? 'err' : ''} />
                </F>

                <button type="submit" className="btn btn--gold cf__submit"
                        disabled={status === 'loading'}>
                  {status === 'loading'
                    ? <><span className="cf__spinner" /> Sending…</>
                    : 'Send Enquiry →'}
                </button>

                {status === 'error' && (
                  <p className="cf__err-msg">
                    Something went wrong. Please email us directly at{' '}
                    <a href="mailto:rakeshcsmail@gmail.com">rakeshcsmail@gmail.com</a>{' '}
                    or{' '}
                    <a href="mailto:rakesh@nativerootsheritage.co.in">rakesh@nativerootsheritage.co.in</a>
                  </p>
                )}
              </form>
            )}
          </div>

          {/* ── Info sidebar ── */}
          <div className="contact-page__info">
            <div className="contact-info-card">
              <h3>Direct Contact</h3>
              <div className="ci__person">
                <div className="ci__name">Rakesh Chandrashekar</div>
                <div className="ci__role">Nativeroots · S R Industries</div>
              </div>
              <div className="ci__items">
                <a href="tel:+918861432099" className="ci__item">
                  <span className="ci__icon">📞</span>
                  <div><strong>Phone</strong><span>+91 88614 32099</span></div>
                </a>
                <a href="https://wa.me/918861432099" className="ci__item"
                   target="_blank" rel="noopener noreferrer">
                  <span className="ci__icon">💬</span>
                  <div><strong>WhatsApp</strong><span>+91 88614 32099</span></div>
                </a>
                <div className="ci__item">
                  <span className="ci__icon">✉</span>
                  <div>
                    <strong>Email</strong>
                    <a href="mailto:rakeshcsmail@gmail.com">rakeshcsmail@gmail.com</a>
                    <br />
                    <a href="mailto:rakesh@nativerootsheritage.co.in">rakesh@nativerootsheritage.co.in</a>
                  </div>
                </div>
                <div className="ci__item">
                  <span className="ci__icon">📍</span>
                  <div>
                    <strong>Location</strong>
                    <span>Shettikere, Tumkur, Karnataka, India</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-info-card contact-info-card--dark">
              <h3>We Can Help With</h3>
              <ul className="ci__list">
                <li>Product specifications &amp; datasheets</li>
                <li>Sample requests</li>
                <li>Pricing for retail &amp; bulk</li>
                <li>Export documentation</li>
                <li>Private label options</li>
              </ul>
            </div>
          </div>

        </div>
      </section>

      <footer className="footer">
        <div className="footer__inner">
          <div className="footer__brand">
            <img src="/images/logo.jpeg" alt="Nativeroots" className="footer__logo" />
            <div>
              <div className="footer__name">Nativeroots</div>
              <div className="footer__sub">S R Industries, Tumkur</div>
            </div>
          </div>
          <nav className="footer__nav">
            <Link to="/">Home</Link>
            <Link to="/products">Products</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <div className="footer__contact">
            <a href="tel:+918861432099">+91 88614 32099</a>
            <div>
              <a href="mailto:rakeshcsmail@gmail.com">rakeshcsmail@gmail.com</a>
              <br />
              <a href="mailto:rakesh@nativerootsheritage.co.in">rakesh@nativerootsheritage.co.in</a>
            </div>
          </div>
        </div>
        <div className="footer__bar">
          © {new Date().getFullYear()} Nativeroots · S R Industries
        </div>
      </footer>
    </main>
  );
}

function F({ label, error, children }) {
  return (
    <div className={`cf__field ${error ? 'cf__field--err' : ''}`}>
      <label>{label}</label>
      {children}
      {error && <span className="cf__ferr">{error}</span>}
    </div>
  );
}
